import __base_store from '@/store/__base_store'

/**
 * Store de información AFIP (modelo `afip_information`) construido desde el factory común.
 */
export default __base_store({
	/** Estado propio del modelo `afip_information`. */
	state: {
		model_name: 'afip_information',
	},
})

